import type { ApiResponse } from "@gollegiella/shared";

/**
 * In dev: requests go to /api/*, Vite proxy strips /api and forwards to Workers at :8787
 * In prod: set VITE_API_BASE to the full Workers URL (e.g. https://gollegiella.workers.dev)
 */
const API_BASE = (import.meta.env.VITE_API_BASE as string | undefined) ?? "/api";

async function request<T>(
  path: string,
  options: RequestInit & { token?: string } = {}
): Promise<ApiResponse<T>> {
  const { token, headers: extraHeaders, ...rest } = options;

  const headers: Record<string, string> = {
    "Content-Type": "application/json",
    ...(extraHeaders as Record<string, string> | undefined),
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };

  try {
    const res = await fetch(`${API_BASE}${path}`, { ...rest, headers });
    return res.json() as Promise<ApiResponse<T>>;
  } catch {
    return { ok: false, error: "Nettverksfeil – prøv igjen" };
  }
}

export const api = {
  post<T>(path: string, body: unknown, token?: string) {
    return request<T>(path, { method: "POST", body: JSON.stringify(body), token });
  },
  get<T>(path: string, token?: string) {
    return request<T>(path, { method: "GET", token });
  },
};
